import { makeStyles } from '@material-ui/core/styles';

import { RiLightbulbLine } from '@remixicon/react';

import { MarkdownContent } from '../MarkdownContent';

const useStyles = makeStyles({
  content: {
    minWidth: 0,
  },
  icon: {
    flexShrink: 0,
    marginTop: 2,
  },
  root: {
    color: 'var(--bui-fg-secondary)',
    display: 'flex',
    gap: 'var(--bui-space-2)',
    padding: 'var(--bui-space-2) 0',
  },
});

export const ThinkingMessage = ({ content }: { content: string }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <RiLightbulbLine size={16} className={classes.icon} />
      <div className={classes.content}>
        <MarkdownContent>{content}</MarkdownContent>
      </div>
    </div>
  );
};
